import { endOfToday, subDays } from 'date-fns';
import { formatDate } from '../utility/dateUtils';

const getTimeRangeFromTodayInDays = days => ({
  start: formatDate(subDays(new Date(), days), 'yyyy-LL-dd'),
  end: formatDate(endOfToday(), 'yyyy-LL-dd'),
});

export const TIME_TO_HIRE_DEFAULT_PERIOD = 1;

export const TIME_TO_HIRE_PERIOD_FILTER = [
  {
    value: 1,
    key: 'last90Days',
    filter: getTimeRangeFromTodayInDays(90),
  },
  {
    value: 2,
    key: 'last30Days',
    filter: getTimeRangeFromTodayInDays(30),
  },
  {
    value: 3,
    key: 'last180Days',
    filter: getTimeRangeFromTodayInDays(180),
  },
  {
    value: 4,
    key: 'last365Days',
    filter: getTimeRangeFromTodayInDays(365),
  },
];
